import React from 'react'
import { t } from 'ttag'

import {
  DEFAULT_CAREER_RESULTS_QUERY_PARAMS,
  DEFAULT_CAREER_TEMPLATES_QUERY_PARAMS,
} from 'constants/templates'
import { Overview } from './tabs/Overview/Overview'
import { Invites } from './tabs/Invites/Invites'
import { Results } from './tabs/Results/Results'

const OVERVIEW = 'overview'
const INVITES = 'invites'
const RESULTS = 'results'

export const TAB_NAMES = { OVERVIEW, INVITES, RESULTS }

export const getDefaultQueryParams = state => {
  const { tab } = state

  const queryParams = {
    [TAB_NAMES.OVERVIEW]: DEFAULT_CAREER_TEMPLATES_QUERY_PARAMS,
    [TAB_NAMES.INVITES]: DEFAULT_CAREER_TEMPLATES_QUERY_PARAMS,
    [TAB_NAMES.RESULTS]: DEFAULT_CAREER_RESULTS_QUERY_PARAMS,
  }

  return queryParams[tab]
}

export const getTabs = () => [
  { id: TAB_NAMES.OVERVIEW, label: t`Overview` },
  { id: TAB_NAMES.INVITES, label: t`Invites` },
  { id: TAB_NAMES.RESULTS, label: t`Results` },
]

export const getTab = state => {
  const { tab } = state

  const tabs = {
    [TAB_NAMES.OVERVIEW]: <Overview />,
    [TAB_NAMES.INVITES]: <Invites />,
    [TAB_NAMES.RESULTS]: <Results />,
  }

  return tabs[tab]
}
